import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../../services/dialog/dialog.service';
import { PreguntaEncuestaDialogComponent } from './modal/pregunta-encuesta.component';

@Component({
  selector: 'encuesta',
  templateUrl: './encuesta.component.html',
  styleUrls: ['./encuesta.component.css']
})
export class EncuestaComponent implements OnInit {

  constructor(private dialogService: DialogService) { }

  private toggleEncuesta: boolean;

  ngOnInit() {
    this.toggleEncuesta=false;
  }

  showHideEncuesta() {
    this.dialogService.open(PreguntaEncuestaDialogComponent);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/encuesta/encuesta.component.ts